import Bowser from 'bowser';
import supportedBrowsers from './config/supportedBrowsers';
import GcAlert from '../GcAlert/index.vue';

export default {
  name: 'GcBrowserAlert',
  components: {
    GcAlert,
  },
  props: {
    browserConfig: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      supported: true,
    };
  },
  mounted() {
    this.setAlert();
  },
  methods: {
    setAlert() {
      const browserConfig = this.browserConfig || supportedBrowsers;
      const browser = Bowser.getParser(window.navigator.userAgent);
      const isSupported = browser.satisfies(browserConfig);
      this.supported = isSupported;
    },
  },
};
